import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_TICKET_ANALYTIC, GET_TICKET_ANALYTIC_SUCCESS, GET_TICKET_ANALYTIC_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getTicketAnalytic({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/analytics/ticket-closure-chart`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_TICKET_ANALYTIC_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_TICKET_ANALYTIC_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_TICKET_ANALYTIC_ERROR, payload: error });
  }
}

export function* watchGetTicketAnalytic() {
  yield takeEvery(GET_TICKET_ANALYTIC, getTicketAnalytic);
}

function* getTicketAnalyticSaga() {
  yield all([fork(watchGetTicketAnalytic)]);
}

export default getTicketAnalyticSaga;